import { Container, Icon, Title, Pin } from "./styles";

type Props = {
  label: string;
  handleClick: () => void;
  pinned: boolean;
  menuIsOpen: boolean;
};

const Control: React.FC<Props> = (props) => {
  const { label, pinned, handleClick, menuIsOpen } = props;
  return (
    <Container onClick={handleClick}>
      <Title>
        {label} {pinned && <Pin />}
      </Title>
      <Icon $menuIsOpen={menuIsOpen} />
    </Container>
  );
};

export default Control;
